import { render, staticRenderFns } from "./CourseDayCRUDBody.vue?vue&type=template&id=f367520e&lang=pug&"
import script from "./CourseDayCRUDBody.vue?vue&type=script&lang=js&"
export * from "./CourseDayCRUDBody.vue?vue&type=script&lang=js&"
import style0 from "./CourseDayCRUDBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports